/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
/* eslint-disable new-cap */
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  numGradeToEUgradeEW,
  formatedSkillStatus,
  FormatDate,
  levelToCEFR,
  calculateIndice,
} from '../../../../helpers/utils';
import img from '../../../../shared/img/logo/logo.png';
import footer from '../../../../shared/img/footer.jpg';

const generatePDF = (courseInfos, report, student, grade, contentTitles, specificSkills) => {
  const bodyObjectives = [];
  if (courseInfos.objectives !== undefined) {
    courseInfos.objectives.forEach((objective) => {
      bodyObjectives.push([objective.name]);
    });
  }

  const items = [
    { title: 'Stagiaire', body: `${student.name} ${student.firstname}` },
    { title: 'Entité', body: courseInfos.company.name },
    { title: 'Intitulé de la formation', body: courseInfos.name },
    { title: 'Langue et niveau du cours', body: (courseInfos.level || courseInfos.level === 0) && courseInfos.language ? `${courseInfos.language.name} - ${levelToCEFR(courseInfos.level)}` : 'n/a' },
    {
      title: 'Formateur',
      body: Array.isArray(courseInfos.idTeachers) && courseInfos.idTeachers.length > 0
        ? courseInfos.idTeachers.map((t) => `${t.name} ${t.firstname}`).join(', ')
        : 'n/a',
    },
    { title: 'Durée', body: `${courseInfos.coursePlan.duration}h` },
    { title: 'Date de début', body: moment(courseInfos.coursePlan.beginDate).format('DD/MM/YYYY') },
    { title: 'Date de fin', body: moment(courseInfos.coursePlan.endDate).format('DD/MM/YYYY') },
    { title: 'Indice de progression', body: calculateIndice(grade.global, report.endlevel.global, (report.presenceSummary.missing + report.presenceSummary.justified + report.presenceSummary.present)) },
    { title: 'Présences', body: report.presenceSummary ? `${report.presenceSummary.present}h/${courseInfos.coursePlan.duration}h` : 'n/a' },
    { title: 'Absences', body: report.presenceSummary ? `${report.presenceSummary.missing + report.presenceSummary.justified}h/${courseInfos.coursePlan.duration}h` : 'n/a' },
  ];

  // formatting skills rows for autoTable
  const bodySkills = [];

  if (contentTitles !== undefined) {
    contentTitles.forEach((contentTitle) => {
      bodySkills.push([{ content: contentTitle.FR, colSpan: 7 }]);
      contentTitle.content.forEach((skill) => {
        if (skill.categories?.includes('vocPro') && courseInfos.coursePlan?.vocPro) {
          skill.categoriesVoc = courseInfos.coursePlan.vocPro;
        }
        if (skill.categories?.includes('vocInterests') && courseInfos.coursePlan?.vocInterests) {
          skill.categoriesVoc = courseInfos.coursePlan.vocInterests;
        }
        if (skill.categories?.includes('vocWork') && courseInfos.coursePlan?.vocWork) {
          skill.categoriesVoc = courseInfos.coursePlan.vocWork;
        }
        let label = skill.FR;
        if (skill.categoriesVoc) {
          let categories = label;
          skill.categoriesVoc.forEach((elem, indexSkill) => {
            if (indexSkill === skill.categoriesVoc.length - 1) {
              categories += ` ${elem}.`;
            } else {
              categories += ` ${elem},`;
            }
          });
          label = categories;
        }
        const skillObj = {
          description: label,
          status: formatedSkillStatus(3),
          date: FormatDate(Date.now()),
          teacher: `${courseInfos.idTeachers[0].name} ${courseInfos.idTeachers[0].firstname}`,
        };
        report.followup?.forEach((skillFollowUp) => {
          if (skillFollowUp.skill === skill._id) {
            skillObj.status = formatedSkillStatus(skillFollowUp.status);
            skillObj.date = FormatDate(skillFollowUp.date);
          }
        });
        bodySkills.push([
          skillObj.description,
          ...skillObj.status,
          skillObj.date,
          skillObj.teacher,
        ]);
      });
    });
  }

  // formatting specific skills rows for autoTable
  if (specificSkills && specificSkills.length > 0) {
    bodySkills.push([{ content: 'Compétences spécifiques', colSpan: 7 }]);
    specificSkills.forEach((skill) => {
      const skillObj = {
        description: skill.FR,
        status: formatedSkillStatus(3),
        date: FormatDate(Date.now()),
        teacher: `${courseInfos.idTeachers[0].name} ${courseInfos.idTeachers[0].firstname}`,
      };
      report.followup.forEach((skillFollowUp) => {
        if (skillFollowUp.skill === skill._id) {
          skillObj.status = formatedSkillStatus(skillFollowUp.status);
          skillObj.date = FormatDate(skillFollowUp.date);
        }
      });
      bodySkills.push([
        skillObj.description,
        ...skillObj.status,
        skillObj.date,
        skillObj.teacher,
      ]);
    });
  }

  // Creating doc
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: 'letter',
  });

  doc.addImage(img, 'PNG', 210, 20, 45, 30);
  // text is placed using x, y coordinates
  doc.setFontSize(12).text('Bilan de fin de formation', doc.internal.pageSize.getWidth() / 2, 70, { align: 'center' });
  doc.setFontSize(12).text(`${student?.name || 'n/a'} ${student?.firstname || 'n/a'} de la société ${courseInfos?.company?.name || 'n/a'}`, doc.internal.pageSize.getWidth() / 2, 85, { align: 'center' });
  // create a line under heading
  doc.setLineWidth(0.1).line(20, 95, 430, 95);

  // Table for global course plan infos
  autoTable(doc, {
    body: items,
    margin: { left: 20, top: 105 },
    styles: { fontSize: 7 },
    columnStyles: { 0: { fontStyle: 'bold' } },
    rowPageBreak: 'avoid',
  });

  // Table for objectives
  autoTable(doc, {
    head: [['Objectifs de la formation: ']],
    body: bodyObjectives,
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
    },
    styles: { fontSize: 7 },
    margin: { left: 20, top: 20 },
    rowPageBreak: 'avoid',
  });

  // Table for scores
  autoTable(doc, {
    head: [
      [{ content: 'Niveaux', colSpan: 8 }],
      [
        { content: 'Niveaux', rowSpan: 2 },
        { content: 'Expression orale', colSpan: 2 },
        { content: 'Compréhension orale', rowSpan: 2 },
        { content: 'Expression écrite', rowSpan: 2 },
        { content: 'Compréhension écrite', rowSpan: 2 },
        { content: 'Niveau global', colSpan: 2 },
      ]],
    body: [
      [
        '',
        'Fluidité',
        'Précision',
        '',
        '',
        '',
        'EWI',
        'CEFR*',
      ],
      [
        'Début de la formation',
        grade && grade.oralFluency ? grade.oralFluency : '',
        grade && grade.oralAccuracy ? grade.oralAccuracy : '',
        grade && grade.listeningComprehension ? grade.listeningComprehension : '',
        grade && grade.writing ? grade.writing : '',
        grade && grade.readingComprehension ? grade.readingComprehension : '',
        grade && grade.global ? grade.global : '',
        grade && grade.global ? numGradeToEUgradeEW(parseFloat(grade.global)) : 'Débutant',
      ],
      [
        'Fin de la formation',
        report.endlevel && report.endlevel.oralFluency ? report.endlevel.oralFluency : '',
        report.endlevel && report.endlevel.oralAccuracy ? report.endlevel.oralAccuracy : '',
        report.endlevel && report.endlevel.listeningComprehension ? report.endlevel.listeningComprehension : '',
        report.endlevel && report.endlevel.writing ? report.endlevel.writing : '',
        report.endlevel && report.endlevel.readingComprehension ? report.endlevel.readingComprehension : '',
        report.endlevel && report.endlevel.global ? report.endlevel.global : '',
        report.endlevel && report.endlevel.global ? numGradeToEUgradeEW(parseFloat(report.endlevel.global)) : 'Débutant',
      ],
    ],
    margin: { left: 20, top: 20 },
    styles: { fontSize: 7, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
      lineWidth: 0.5,
    },
    bodyStyles: { lineWidth: 0.5 },
    theme: 'grid',
    showFoot: 'lastPage',
    rowPageBreak: 'avoid',
    didParseCell(data) {
      const rows = data.table.body;
      if (data.row.index === 0) {
        data.cell.styles.fillColor = [255, 255, 255];
        // data.cell.styles.fontSize = 8;
        // data.cell.styles.fontStyle = 'bold';
      }
    },
  });

  // Table for levels interpretation
  autoTable(doc, {
    head: [
      [{ content: 'Tableau d\'interprétation des niveaux', colSpan: 10 }],
      ['', 'Débutant', 'Elémentaire', 'Pré-intermédiaire', { content: 'Intermédiaire', colSpan: 2 }, 'Avancé', 'Autonome', 'Maîtrise', 'Bilingue']],
    body: [
      ['EWI', '0-2', '3', '4', '5', '6', '7', '8', '9', '10'],
      [{ content: 'Conseil de l\'Europe*', rowSpan: 2 }, '', 'A1', 'A2', { content: 'B1', colSpan: 2 }, 'B2', 'C1', 'C2', ''],
      ['Débutant', { content: 'Utilisateur élémentaire', colSpan: 2 }, { content: 'Utilisateur indépendant', colSpan: 3 }, { content: 'Utilisateur expérimenté', colSpan: 2 }, ''],
    ],
    foot: [
      [{ content: '* Cadre européen commun de référence pour les langues (CECR)', colSpan: 8 }],
    ],
    margin: { left: 20, top: 20 },
    styles: { fontSize: 7, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
      lineWidth: 0.5,
    },
    footStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 6,
      lineWidth: 0.5,
      halign: 'left',
      fontStyle: 'normal',
    },
    rowPageBreak: 'avoid',
    bodyStyles: { lineWidth: 0.5 },
    columnStyles: { 4: { cellWidth: 30 }, 5: { cellWidth: 30 } },
    theme: 'grid',
  });

  // Table for teacher's commentary
  autoTable(doc, {
    head: [['Commentaire formateur:']],
    body: [[report.comment]],
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
    },
    styles: { fontSize: 7 },
    margin: { left: 20, top: 20 },
    rowPageBreak: 'avoid',
  });

  // Table for skills
  autoTable(doc, {
    head: [[
      'Compétences', 'Non acquis', 'Partiellement acquis', 'Acquis', 'Non applicable', 'Date', 'Formateur',
    ]],
    body: bodySkills,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 7, valign: 'middle' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 8,
      lineWidth: 0.5,
    },
    columnStyles: {
      1: { halign: 'center' },
      2: { halign: 'center' },
      3: { halign: 'center' },
      4: { halign: 'center' },
    },
    bodyStyles: { lineWidth: 0.5 },
    rowPageBreak: 'avoid',
    theme: 'grid',
  });

  // Creating footer and saving file
  autoTable(doc, {
    body: [[{ content: '', colSpan: 1 }]],
    styles: {
      fontSize: 7,
      minCellWidth: 300,
      minCellHeight: 110,
      lineWidth: 0,
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      lineWidth: 0,
    },
    theme: 'grid',
    margin: { left: 20, top: 30 },
    rowPageBreak: 'avoid',
    didDrawCell(data) {
      const textPos = data.cell;
      data.cell.styles.fillColor = [255, 255, 255];
      doc.addImage(footer, textPos.x + 50, textPos.y + 5, 320, 100);
    },
  });
  doc.save(`${student.name}_${student.firstname}_report.pdf`);
};

export {
  generatePDF,
};
